import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  LectureTypeSelect,
  rescheduleClassesCurrentFiltersSelector,
  RESCHEDULE_CLASSES_FILTERS,
  setRescheduleFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';

function RescheduleClassesLectureTypeFilter() {
  const dispatch = useDispatch();
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };
  const { lectureType } = useSelector(rescheduleClassesCurrentFiltersSelector);

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.lectureType,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );
  return (
    <Field
      label="Lecture Type"
      labelClassName="h5"
    >
      <LectureTypeSelect
        value={lectureType}
        placeholder="Select from dropdown"
        onChange={handleOnChange}
        styles={_styles}
      />
    </Field>
  );
}

export default RescheduleClassesLectureTypeFilter;
